<template>
<div class="chapter">
<div class="inner_page">
<div>
<div class="chapter" id="ded">
<p class="ded">To all my colleagues,<br/>   past and present,<br/>      in St Mary’s College,<br/>         University of St Andrews</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-bauckham-0004.vue?c55ef560